module.exports = __webpack_public_path__ + "svg/report.4e4a06b4decdd42bbf3c683e59cf5faa.svg";